import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ComboCausaEliminacion/addComboCausaEliminacion`, method: 'POST', body: values, token: token})
}
